// ============================================================
// CONTENUTI DEL SITO
// - Membri ed eventi si modificano dal PANNELLO ADMIN (/admin)
//   oppure nei file public/data/members.json e public/data/events.json
// - Questo file contiene i contenuti fissi: contatti, manifesto, immagini
// ============================================================

export const MOVEMENT = {
  name: "Progetto Città",
  type: "Movimento Civico",
  motto: "Ascolto · Cura · Solidarietà",
  cities: "Trapani · Erice",
};

export const ASSOCIATION = {
  legalName: 'Associazione-Movimento politico "Progetto Città"',
  address: "Via Claudio Monteverdi n. 33, 91016 Erice (Casa Santa)",
  cf: "93095050816",
  quotaAnnuale: "10,00",
};

export const CONTACTS = {
  email: "info@progettocitta.mov",
  phoneDisplay: "+39 388 933 4485",
  // Numero WhatsApp con prefisso internazionale, senza "+" e senza spazi
  whatsappNumber: "393889334485",
  address: "Trapani ed Erice — provincia di Trapani",
  whatsappMessage: "Ciao! Vi contatto dal sito di Progetto Città: vorrei fare una domanda / una segnalazione.",
};

export const SOCIALS = {
  facebook: "https://www.facebook.com/profile.php?id=61590944302762",
  whatsappChannel: "https://whatsapp.com/channel/0029Vb8GXCIJJhzTcIilG03p",
};

export const waLink = (message = CONTACTS.whatsappMessage) =>
  `https://wa.me/${CONTACTS.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const MANIFESTO = [
  {
    num: "01",
    title: "Ascolto",
    text: "Ogni voce conta. Percorriamo i quartieri di Trapani ed Erice, incontriamo i cittadini, raccogliamo bisogni e idee: una città migliore nasce dal basso, mai dall'alto.",
  },
  {
    num: "02",
    title: "Cura",
    text: "Ci prendiamo cura degli spazi comuni, delle periferie e dell'ambiente. Prendersi cura del territorio significa prendersi cura delle persone che lo abitano.",
  },
  {
    num: "03",
    title: "Solidarietà",
    text: "Nessuno resta indietro. Sosteniamo chi è in difficoltà con azioni concrete: reti di vicinato, raccolte solidali, sportelli di aiuto.",
  },
  {
    num: "04",
    title: "Partecipazione",
    text: "Le decisioni si prendono insieme. Assemblee aperte, proposte condivise, trasparenza totale: la cosa pubblica torna ad essere di tutti.",
  },
];

export const IMAGES = {
  hero: "/images/saline-trapani.jpg",
  community: "/images/costa-trapani.jpg",
  porto: "/images/porto-trapani.jpg",
};
